(ns teamoesterreich.admin-mode.content.blog-admin-list
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.blog :as d-blog]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]

            [reagent-material-ui.icons.build :refer [build]]
            [reagent-material-ui.icons.add :refer [add]]

            ))



(defn time-conv [rest-time]
  (if (= "" (str rest-time))
    nil
    (js/Date. (str (subs rest-time 0 4) "-" (subs rest-time 4 6) "-" (subs rest-time 6 11) ":" (subs rest-time 11 13) ":" (subs rest-time 13 19) "-00:00"))))

(defn time-print [rest-time]
  (if (= "" (str rest-time))
    nil
    (let [d (time-conv rest-time)] (str (.toLocaleDateString d) " " (subs (.toLocaleTimeString d) 0 5)))))




(defn text-block-card [text !opened]
  (let [opened? (= @!opened (get text :webBlog-uuid))
        type (get text :webBlog-type)
        ]
    [mui/card {:style {:backgroundColor (if (get text :webBlog-published) "" "#e6e6e5") :marginBottom "20px"}}
     [mui/card-header
      {:title
       (r/as-element [mui/grid
                      {:container  true
                       :direction  "row"
                       :alignItems "stretch"
                       :justify    "flex-start"
                       }
                      [mui/grid
                       {:item  true
                        :md    4
                        :xs    12
                        :style {:height "80px" :textAlign "left" :paddingLeft ""}
                        }
                       [:img {:src (:webBlog-imageUri text) :alt "Kein Bild" :height "80"}]
                       ]

                      [mui/grid
                       {:item  true
                        :md    8
                        :xs    12
                        :style {:height "80px" :textAlign "left" :paddingLeft "20px"}
                        }
                       [mui/typography {:variant "h5"} (str (time-print (get text :webBlog-date)) " - " (get text :webBlog-title) (when-not (get text :webBlog-published) " - [unveröffentlicht]"))]]]
                     )}]

     [mui/card-actions

      [mui/button {:startIcon (r/as-element [build])
                   :onClick   (fn []
                                (reset! !opened (get text :webBlog-uuid))
                                (a/set-page :blog-edit))
                   }
       "Bearbeiten"
       ]
      ]

     ]))

(defn get-it []
  (let [!webBlog-list (r/cursor vstate/app-state [:webBlog-list])
        !loaded? (r/cursor !webBlog-list [:loaded])
        !data (r/cursor !webBlog-list [:data])
        !opened (r/cursor !webBlog-list [:opened])
        !show-create-modal (r/cursor !webBlog-list [:create])
        reload-fn #(reset! !loaded? false)]
    (fn []
      (when-not @!loaded?
        (do
          (d-blog/get-blog-list
            (fn [response]
              (swap! !webBlog-list assoc :loaded true :data response)))


          ))

      [mui/paper
       {:style {:padding "10px" :marginTop "5px"}}


       [mui/grid
        {:container  true
         :direction  "row"
         :alignItems "stretch"
         :justify    "flex-start"
         :style      {:textAlign "left"}
         }
        [mui/grid
         {:item  true
          :xs    10
          :style {:height "50px"}
          }
         [mui/typography {:variant "h5" :style {:margin "12px 0 0 400px"}
                          :onClick reload-fn}
          "Artikel"]]

        [mui/grid
         {:item  true
          :xs    2
          :style {:height "50px"}
          }
         [ws-event-sync-component/ws-event-reload !loaded? :webBlog]]



        [create-with-name-modal/modal !show-create-modal
         "Bitte gib einen Namen für den neuen Artikel ein"
         "Anlegen"
         (fn [name]
           (log/debug "Create Blog with Name: " name)
           (d-blog/>new-blog name (fn [new]
                                    (log/debug "Created Blog : " new)
                                    (reload-fn)
                                    (reset! !opened (:webBlog-uuid new))
                                    (a/set-page :blog-edit)
                                    ))
           )
         ]
        [mui/grid
         {:item  true
          :xs    12
          :style {:height "50px"}
          }
         [mui/button {:startIcon (r/as-element [add])
                      :variant   "outlined"
                      :color     "secondary"
                      :onClick   #(reset! !show-create-modal true)
                      }
          "Einen neuen Artikel anlegen"
          ]]

        (for [[uuid text] (reverse (sort-by (fn [[uuid n]] (:webBlog-date n)) (filter (fn [[uuid n]] (:webBlog-active n)) @!data)))]
          ^{:key (str "webBlog-" uuid)}
          [mui/grid
           {:container false
            :item      true
            :xl        7
            :xs        12                                   ;extra-small: 0px
            }
           [text-block-card text !opened]
           ]
          )
        ]]

      ))

  )

